__webpack_public_path__ = `${SETTINGS.public_path}` // eslint-disable-line no-undef, camelcase
// bootstrap
import "bootstrap/dist/css/bootstrap.min.css"

// react-virtualized requirement
import "react-virtualized/styles.css"
import "react-virtualized-select/styles.css"
import "cropperjs/dist/cropper.css"

// react-select styles
import "react-select/dist/react-select.css"
// react-slick styles
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

// react-datepicker styles
import "react-datepicker/dist/react-datepicker.css"

// react-geosuggest styles
import "react-geosuggest/module/geosuggest.css"

// react-telephone-input stylesheet
import "react-telephone-input/css/default.css"

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

// This should come last to override other styles
import "../../scss/layout.scss"
